import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
//React
import React, { Component } from 'react';
//import * as ReactDOM from 'react-dom';
import { Route } from 'react-router-dom';
//Apollo
import ApolloClient from "apollo-client";
import { ApolloProvider } from "react-apollo";
import { Query } from "react-apollo";
import 'whatwg-fetch';
//Components
import LiveView from './components/DetailView/LiveView'
import LiveViewOnly from './components/DetailView/LiveViewOnly'
import DetailContainerStandalone from './components/DetailView/DetailContainerStandalone'
import Setter from './components/RuleSetter/Setter'
import SetterTenant from './components/RuleSetter/SetterTenant'
import SetterTicket from './components/RuleSetter/SetterTicket'
//Fabric IO
import FilterBox from './components/SearchBox/FilterBox'
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { app, authentication } from "@microsoft/teams-js";
import Utils from "./components/common/Utils";
import { Depths } from '@uifabric/fluent-theme/lib/fluent/FluentDepths';
import { FontSizes, Stack, Toggle } from 'office-ui-fabric-react/lib';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { Pivot, PivotItem } from 'office-ui-fabric-react/lib';
import ProductLicense from './components/Legal/ProductLicense'

//STYLE
import './App.scss'
import DayView from "./components/DayView/DayView";
import DashboardView from "./components/DashboardView/DashboardView";
import SettingsView from "./components/SettingsView/SettingsView";
import ReportView from "./components/ReportView/ReportView";
import Upload from "./components/UploadView/UpLoad";
import Login from "./components/Login/Login";
import Logout from "./components/Login/Logout";
import LoginResult from "./components/Login/LoginResult";
import Config from "./components/Login/Config";
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { TooltipDelay } from 'office-ui-fabric-react/lib/Tooltip';
import Termsofuse from "./components/Legal/Termsofuse";
import Product from "./components/Legal/Product";
import Privacy from "./components/Legal/Privacy";
import BotRegistration from "./components/Legal/BotRegistration";
import TransactableView from "./components/Transactable/TransactableView";
import Impressum from "./components/Legal/Impressum";
import AuthenticationContext from "adal-angular";
import jwt_decode from "jwt-decode";
import solutenLogo from './styles/images/RI-new-logo.png';

//import ShopControler from "./components/ShopView/ShopControler";

import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

import {
    renderSearchTeams,
    renderZoomAuthorize,
    renderWebexAuthorize
} from "./queries/queryRecordings";
import { queryGetAuth, mutationLogout } from "./queries/querySettings";
import { renderPanelRecording, renderPanelRules, renderPanelSettings, renderPanelUpload, renderPanelTenant, renderPanelDashboard, renderPanelCompliance, renderPanelNewsFeed, renderPanelTicket } from "./panel/helpPanel";
import { iniApplicationId, iniGraphqlUrl, iniGraphMicrosoft } from "./ini/ini";
import { Providers, SimpleProvider, ProviderState } from '@microsoft/mgt/dist/commonjs';

import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import Contact from "./components/Legal/Contact";
//import Pricing from "./components/ShopView/SubPages/Pricing";
import { MyContext } from '../src/context';
import { ThemeProvider, PartialTheme } from '@fluentui/react-theme-provider';
import ComplianceView from './components/ComplianceView/ComplianceView';
import ComplianceLicense from './components/ComplianceView/ComplianceLicense';
import ConversationSafe from './components/ConversationSafe/ConversationSafe';
import MyQueue from './components/ConversationSafe/MyQueue';


initializeIcons('https://res-1.cdn.office.net/files/fabric/assets/icons/');

// Read DarkMode
const ASCThemeNormal: PartialTheme = {
    palette: {
        themePrimary: '#00315e',
        themeLighterAlt: '#cfdeec',
        themeLighter: '#a8c2da',
        themeLight: '#84a7c8',
        themeTertiary: '#648fb7',
        themeSecondary: '#4978a5',
        themeDarkAlt: '#316493',
        themeDark: '#1d5182',
        themeDarker: '#0c4070',
        neutralLighterAlt: '#f1f1f1',
        neutralLighter: '#ededed',
        neutralLight: '#e3e3e3',
        neutralQuaternaryAlt: '#d3d3d3',
        neutralQuaternary: '#cacaca',
        neutralTertiaryAlt: '#c2c2c2',
        neutralTertiary: '#595959',
        neutralSecondary: '#373737',
        neutralPrimaryAlt: '#2f2f2f',
        neutralPrimary: '#000000',
        neutralDark: '#151515',
        black: '#0b0b0b',
        white: '#f7f7f7',
    },
    type: "normal"
};

const ASCThemeContrast: PartialTheme = {
    palette: {
        themePrimary: '#71a2d2',
        themeLighterAlt: '#050608',
        themeLighter: '#121a21',
        themeLight: '#22303f',
        themeTertiary: '#44617d',
        themeSecondary: '#638eb8',
        themeDarkAlt: '#7da9d6',
        themeDark: '#8fb6dc',
        themeDarker: '#aac8e5',
        neutralLighterAlt: '#0b0b0b',
        neutralLighter: '#151515',
        neutralLight: '#252525',
        neutralQuaternaryAlt: '#2f2f2f',
        neutralQuaternary: '#373737',
        neutralTertiaryAlt: '#595959',
        neutralTertiary: '#c8c8c8',
        neutralSecondary: '#d0d0d0',
        neutralPrimaryAlt: '#dadada',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',
        black: '#f8f8f8',
        white: '#000000'
    },
    type: "contrast"
};

const ASCThemeDark: PartialTheme = {
    palette: {
        themePrimary: '#71a2d2',
        themeLighterAlt: '#050608',
        themeLighter: '#121a21',
        themeLight: '#22303f',
        themeTertiary: '#44617d',
        themeSecondary: '#638eb8',
        themeDarkAlt: '#7da9d6',
        themeDark: '#8fb6dc',
        themeDarker: '#aac8e5',
        neutralLighterAlt: '#2b2b2b',
        neutralLighter: '#333333',
        neutralLight: '#414141',
        neutralQuaternaryAlt: '#4a4a4a',
        neutralQuaternary: '#515151',
        neutralTertiaryAlt: '#6f6f6f',
        neutralTertiary: '#e0e0e0',
        neutralSecondary: '#e5e5e5',
        neutralPrimaryAlt: '#eaeaea',
        neutralPrimary: '#d1d1d1',
        neutralDark: '#f4f4f4',
        black: '#f9f9f9',
        white: '#202020',
    },
    type: "dark"
};

window.isTeamsGlobal = false;


// Expose the active theme as a body class
let applyThemeToBody = (activeTheme) => {
    document.body.style.backgroundColor = activeTheme.palette.neutralLighterAlt;
    document.body.classList.remove("theme-normal", "theme-dark", "theme-contrast");
    document.body.classList.add("theme-" + activeTheme.type);
};

let theme = (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? ASCThemeDark : ASCThemeNormal;
applyThemeToBody(theme);

const ADAL_BASE_QUERY = "scope=openid+profile";

let config = {
    clientId: iniApplicationId,
    redirectUri: window.location.origin + "/loginResult",
    cacheLocation: "localStorage",
    navigateToLoginRequestUrl: false,
    extraQueryParameter: ADAL_BASE_QUERY
};
let authContext = new AuthenticationContext(config); // from the ADAL.js library

// A silent request must name exactly one account: either ADAL's own sid, or the login_hint
// of the account the user picked. Sending both is rejected with AADSTS90138.
function prepareSilentTokenRequest() {
    let hint = Utils.lsGet("login_hint");
    if (!hint) {
        authContext.config.extraQueryParameter = ADAL_BASE_QUERY;
        return;
    }
    let cached = authContext.getCachedUser();
    let cachedName = cached ? (cached.userName || (cached.profile && cached.profile.preferred_username)) : null;
    if (cachedName && cachedName.toLowerCase() === String(hint).toLowerCase()) {
        // ADAL's sid identifies the session more precisely, let it do the hinting
        authContext.config.extraQueryParameter = ADAL_BASE_QUERY;
        return;
    }
    if (cached) {
        // Cache is for another account, its sid would point at the wrong session
        console.log("Clear Cache: cached user " + cachedName + " is not the picked account " + hint);
        authContext.clearCache();
        authContext._user = null;
    }
    authContext.config.extraQueryParameter = ADAL_BASE_QUERY + "&login_hint=" + encodeURIComponent(hint);
}

// <mgt-login> caches /me and the photo in IndexedDB under the key "me", for an hour, and does not
// know which account it belongs to. MGT only clears it on a SignedIn -> SignedOut switch inside the
// same page, which never happens because logout() navigates away. So after switching accounts the
// header kept showing the previous user. Tie the cache to the account (oid) that filled it.
const MGT_DATABASES = ["mgt-users", "mgt-photos", "mgt-people", "mgt-presence", "mgt-groups", "mgt-responses", "mgt-files", "mgt-file-lists"];

function clearMgtCache() {
    if (!window.indexedDB) {
        return;
    }
    // MGT's own open() calls queue behind these deletes, so no need to wait for them
    MGT_DATABASES.forEach(name => {
        try {
            window.indexedDB.deleteDatabase(name);
        } catch (e) {
            console.log("Could not clear " + name + ": " + e);
        }
    });
}

function setGraphProviderSignedIn() {
    let user = authContext.getCachedUser();
    let owner = user && user.profile ? user.profile.oid : null;
    if (owner && Utils.lsGet("mgt_cache_owner") !== owner) {
        console.log("Clear MGT cache: it belongs to another account");
        clearMgtCache();
        Utils.lsSet("mgt_cache_owner", owner);
    }
    provider.setState(ProviderState.SignedIn);
}

let timerId = null;

let authTokenSuccess = (result) => {
    Utils.lsSet("access_token", result);
    console.log("SSO login successfull");
};

let authTokenRequest = {
    successCallback: authTokenSuccess,
    failureCallback: function (error) { console.log("Failure: " + error); },
};

const authLink = setContext((_, { headers }) => {
    if (window.location.pathname.includes("shop") || window.location.pathname.includes("callDetail")) {
        return;
    }
    // get the authentication token from local storage if it exists    

    const token = Utils.lsGet("access_token");
    // Check Token Validation
    var decoded = jwt_decode(token);
    var expire = decoded.exp;
    var remaining = parseInt(decoded.exp - Date.now() / 1000);

    console.log("Valid for " + remaining + " seconds");
    if (remaining < 300) {
        // Renew token
        console.log("Renew Token");
        if (window.isTeamsGlobal) {
            authentication.getAuthToken().then((ssoToken) => {
                // SSO-Token erfolgreich erhalten
                Utils.lsSet("access_token", ssoToken);
            }).catch((error) => {
                console.log("Teams SSO token renewal failed: " + error);
                // Token renewal failed (e.g. password changed), clear stale cache and force interactive login
                authContext.clearCache();
                authContext._user = null;
                Utils.lsRemove("access_token");
                login();
            })
        }
        else {
            var tokenId = authContext.getCachedToken(iniApplicationId);
            prepareSilentTokenRequest();
            authContext._renewIdToken(function (err, tokenId) {
                if (err) {
                    console.log("Renewal access token failed: " + err);
                    // Token renewal failed (e.g. password changed), clear stale cache and force interactive login
                    authContext.clearCache();
                    authContext._user = null;
                    Utils.lsRemove("access_token");
                    // show the account picker, else Entra signs in with another session in this browser
                    window.sessionStorage.setItem("ri_select_account", "1");
                    login();
                }
                else {
                    let token = authContext.getCachedToken(iniApplicationId);
                    Utils.lsSet("access_token", token);
                };
            });
        }
    }
    // Extract tenantId from token if available
    let tenantId = decoded.tid || decoded.tenantId || "";
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
            ...(tenantId && { "x-tenant-id": tenantId })
        }
    }
});

const httpLink = createHttpLink({
    uri: iniGraphqlUrl
});

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache({
        dataIdFromObject: object => {
            switch (object.__typename) {
                case 'UserType': return object.userId || object.id;
                case 'Userdata': return object.userId || object.id;
                default: return object.id || object._id;
            }
        }
    })
});


let pp = window.location.href;

function getAccessToken(scopes) {
    return authContext.getCachedToken(iniGraphMicrosoft);
}

function login() {
    if (window.isTeamsGlobal) {
        // Teams-Login. In teams-js v2 authenticate is on "authentication", "app.authentication" is undefined
        authentication.authenticate({
            url: window.location.origin + "/login",
            width: 600,
            height: 535,
            successCallback: function (result) {
                console.log("authentication succeeded: ", result);
                window.location.reload();
            },
            failureCallback: function (reason) {
                console.log("authentication failed: ", reason);
                window.location.reload();
            }
        });
    } else {
        //save current path to redirect after login
        localStorage.setItem('postLoginRedirect', window.location.pathname);

        // Fallback: Direkt auf Login-Seite weiterleiten
        window.location.href = window.location.origin + "/login";
    }
}

function logout() {
    try {
        var auth = { locale: navigator.language, timeZone: new Date().getTimezoneOffset(), timeZoneId: new Intl.DateTimeFormat().resolvedOptions().timeZone };
        client.mutate({ mutation: mutationLogout, variables: { auth: auth } });
    } catch (e) {
        console.error("Server-side logout failed:", e);
    }
    authContext.clearCache();
    authContext._user = null;
    Utils.lsRemove("login_hint");
    clearMgtCache();
    Utils.lsRemove("mgt_cache_owner");
    window.location.href = window.location.origin + "/logout";
}

let provider = new SimpleProvider(getAccessToken, login, logout);
provider.setState(ProviderState.SignedOut);
Providers.globalProvider = provider;

export default class App extends Component {


    constructor(props) {
        super(props);
        this.handler = this.handler.bind(this);
        this.LiveViewRef = React.createRef();
        // ADAL renews tokens in hidden iframes that load /loginResult, so the whole App is constructed
        // there too. localStorage is shared with the visible window: don't delete its token from there.
        this.isAdalFrame = Utils.isAdalFrame();
        if (!this.isAdalFrame) {
            // Delete access_token
            Utils.lsRemove("access_token");
            Utils.lsSet("adal_authentication", "0");
        }
        this.timerID = null;
        this.tokenRenewalTimerID = null;
    }
    displayName = App.name;
    commandBarSync = React.createRef();

    state = {
        isDebug: true,
        isteams: false,
        userContext: null,
        loginChecked: false,
        loginChecked2: false,
        auth: null,
        id: "0",
        val: "",
        withSave: false,
        backgroundColor: "#F7F7F7",
        shopState: null,
        helpMode: Utils.lsGet("helpMode") === "true" ? true : false,
        helpPanel: false,
        configurationPanel: false,
        newsPanelIsOpen: false,
        access_token: null,
        selectedPivot: Utils.lsGet("selectedPivot") != null ? (Utils.lsGet("selectedPivot")) : ".0",
        iconView: true,
        isRefresh: true,
        isConversationSafeNew: true,
        searchIn: [],
        clientWidth: window.innerWidth
    };

    handleResize = () => {
        this.setState({ clientWidth: window.innerWidth });
    };

    handler(search, filter, save, searchIn) {
        this.setState({ id: "1", val: search, filter: filter, withSave: save, searchIn: searchIn })
    }
    switchView = () => {
        if (this.state.isRefresh) {
            this.setState({ isRefresh: false })
        }
        //isConversationSafeNew is true only if the conversation safe was not accessed
        if (this.state.isConversationSafeNew && this.state.id == "2") {
            this.setState({ isConversationSafeNew: false })
        }
        this.setState({ iconView: this.state.iconView ? false : true, backgroundColor: '#F7F7F7' })
    };

    newsPanelOpen = () => {
        this.setState({ newsPanelIsOpen: true });
    }

    newsPanelClose = () => {
        this.setState({ newsPanelIsOpen: false });
    }

    authTokenSuccess = (result) => {
        Utils.lsSet("access_token", result);
        console.log("SSO login successfull");
        Utils.lsSet("adal_authentication", "0");
        this.setState({ access_token: result });
    };

    authTokenRequest = {
        successCallback: this.authTokenSuccess,
        failureCallback: function (error) { console.log("Failure: " + error); },
    };


    componentDidMount() {
        // In ADAL's renewal iframe only LoginResult matters. Without this the iframe ran its own renewal
        // timer, could renew before the visible window, and on failure cleared the shared cache and
        // opened the login page inside the hidden iframe, leaving the visible page without a token.
        if (this.isAdalFrame) {
            return;
        }
        document.title = "ASC Recording Insights";
        Utils.lsSet("refreshView", "no");
        //Managing redirect from new ui 
        if (window.location.search === "?enabledNewUI=NO" && (window.location.pathname === "/main" || window.location.pathname === "/")) {
            window.sessionStorage.setItem("enabledNewUI", "NO");
            Utils.lsSet("selectedPivot", ".0")
            window.location.href = window.location.pathname
        }
        //managed new and old ui
        switch (window.location.pathname) {
            case "/main/dashboard": {
                Utils.lsSet("selectedPivot", ".1")
                window.location.href = "/main"
                break;
            }
            case "/main/compliance": {
                Utils.lsSet("selectedPivot", ".2")
                window.location.href = "/main"
                break;
            }
            case "/main/settings": {
                Utils.lsSet("selectedPivot", ".3")
                window.location.href = "/main"
                break;
            }
            case "/main/configuration": {
                Utils.lsSet("selectedPivot", ".4")
                window.location.href = "/main"
                break;
            }
            case "/main/tenant": {
                Utils.lsSet("selectedPivot", ".5")
                window.location.href = "/main"
                break;
            }
            default: break;
        }

        window.addEventListener('resize', this.handleResize);
        app.initialize().then(() => {
            //redirect for the manifest -> enabledNewUI = YES go to the new ui
            const enabledNewUI = window.sessionStorage.getItem("enabledNewUI")

            if (enabledNewUI === "YES" && window.location.pathname === "/") {
                console.log("try redirect : ", window.location.origin + "/ui")
                window.location.href = window.location.origin + "/ui"
            }
            // Try Teams approach to get token
            authentication.getAuthToken()
                .then((ssoToken) => {
                    // SSO-Token erfolgreich erhalten
                    Utils.lsSet("access_token", ssoToken);
                    console.log("SSO login successfull");
                    Utils.lsSet("adal_authentication", "0");
                    this.setState({ access_token: ssoToken });
                })
                .catch((error) => {
                    // Fehlerbehandlung
                    console.error("Fehler beim Abrufen des SSO-Tokens:", error);
                    // The checkTeamsAuthentication timer will fallback to ADAL, which handles password-change errors itself.
                });
            app.getContext().then((context) => {
                // Read if Dark Mode
                //console.log("Teams Context: ", context)
                //console.log("Theme: " + context.app.theme)
                theme = context.app.theme === "dark" ? ASCThemeDark : (context.app.theme === "contrast" ? ASCThemeContrast : ASCThemeNormal)
                applyThemeToBody(theme);

                if (authContext.getCachedUser() != null && authContext.getCachedUser().profile.upn !== context.user?.loginHint) {
                    // Then delete old user and force new check
                    console.log("Clear Cache");
                    // User doesn't match, clear the cache
                    authContext.clearCache();
                    window.location.reload();
                } else {
                    this.setState({ isteams: true, userContext: context }, () => { window.isTeamsGlobal = true; });
                }
            });
        }).catch(() => {
            this.setState({ isteams: false }, () => { window.isTeamsGlobal = false; });
        });

        var isState = window.localStorage.getItem("saved_state");
        if (isState) {
            this.setState({ id: isState });
            window.localStorage.setItem("saved_state", "0");
        }

        // Start periodic token renewal check (every 60 seconds)
        this.startTokenRenewalTimer();
    };


    // Periodic token renewal - runs independently of user interaction
    startTokenRenewalTimer = () => {
        if (this.tokenRenewalTimerID) {
            clearInterval(this.tokenRenewalTimerID);
        }
        // Check every 60 seconds
        this.tokenRenewalTimerID = setInterval(() => this.checkAndRenewToken(), 60000);
    };

    checkAndRenewToken = () => {
        if (window.location.pathname.includes("shop") || window.location.pathname.includes("callDetail")) {
            return;
        }
        const token = Utils.lsGet("access_token");
        if (!token) {
            return;
        }
        try {
            var decoded = jwt_decode(token);
            var remaining = parseInt(decoded.exp - Date.now() / 1000);
            console.log("Token renewal check - Valid for " + remaining + " seconds");
            if (remaining < 300) {
                console.log("Proactive token renewal triggered");
                if (window.isTeamsGlobal) {
                    authentication.getAuthToken().then((ssoToken) => {
                        Utils.lsSet("access_token", ssoToken);
                        console.log("Proactive SSO token renewal successful");
                    }).catch((error) => {
                        console.error("Proactive SSO token renewal failed:", error);
                        // Token renewal failed (e.g. password changed), clear the stale token and force re-authentication
                        Utils.lsRemove("access_token");
                        login();
                    });
                } else {
                    authContext._renewIdToken(function (err, tokenId) {
                        if (err) {
                            console.log("Proactive token renewal failed: " + err);
                            // Token renewal failed (e.g. password changed), clear stale cache and force interactive login.
                            
                            authContext.clearCache();
                            authContext._user = null;
                            Utils.lsRemove("access_token");
                            // show the account picker, else Entra signs in with another session in this browser
                            window.sessionStorage.setItem("ri_select_account", "1");
                            login();
                        } else {
                            let newToken = authContext.getCachedToken(iniApplicationId);
                            if (newToken) {
                                Utils.lsSet("access_token", newToken);
                                console.log("Proactive ADAL token renewal successful");
                            }
                        }
                    });
                }
            }
        } catch (e) {
            console.error("Token renewal check error:", e);
        }
    };

    componentWillUnmount() {
        if (this.tokenRenewalTimerID) {
            clearInterval(this.tokenRenewalTimerID);
        }
        if (this.timerID) {
            clearInterval(this.timerID);
        }
        window.removeEventListener('resize', this.handleResize);
    }

    // Check Authentication
    checkTeamsAuthentication = () => {
        console.log("checkTeamsAuthentication: ", this.timerID);
        // access_token in state is only ever set by the Teams SSO flow; the ADAL (browser)
        // flow only writes to localStorage, so also check that here or this timer never stops.
        if (this.state.access_token == null && Utils.lsGet("access_token") == null) {
            // Then use old Authentication
            console.log("Use old authentication");
            Utils.lsSet("adal_authentication", "1");
            this.authenticateUser();
        }
        else {
            clearInterval(this.timerID);
        }
    }

    componentDidUpdate() {

        window.localStorage.setItem("saved_state", this.state.id);
    }

    // Old Adal Login
    authenticateUser = () => {
        if (!this.state.loginChecked || !this.state.loginChecked2) {
            if (!this.state.loginChecked) {
                console.log("Authenticate User 1");
                this.setState({ loginChecked: true });
            }
            else {
                console.log("Authenticate User 2");
                this.setState({ loginChecked2: true });
                clearInterval(this.timerID);
            }
            let user = authContext.getCachedUser();
            if (this.state.userContext != null && this.state.userContext.loginHint) {
                if (user) {
                    console.log("LoginHint: " + this.state.userContext.loginHint + " UserName: " + user.profile.upn);

                    if (user.profile.upn !== this.state.userContext.loginHint) {
                        console.log("Clear Cache");
                        // User doesn't match, clear the cache
                        authContext.clearCache();
                        window.location.reload();
                    }
                }
            }
            let token = authContext.getCachedToken(iniApplicationId);
            if (token) {
                let accessToken = authContext.getCachedToken(iniGraphMicrosoft);
                if (accessToken == null) {
                    authContext.acquireToken(iniGraphMicrosoft, function (error, access_token) {
                        if (error || !access_token) {
                            console.log('ADAL error occurred: ' + error);
                        }
                        else {
                            setGraphProviderSignedIn();
                            this.setState({ auth: { tenantId: user.profile.tid, userId: user.profile.oid, sessionToken: token, locale: user.profile.locale, timeZone: new Date().getTimezoneOffset(), timeZoneId: new Intl.DateTimeFormat().resolvedOptions().timeZone } });
                            Utils.lsSet("access_token", token);

                        }
                    }.bind(this)
                    );
                } else {
                    setGraphProviderSignedIn();
                    this.setState({ auth: { tenantId: user.profile.tid, userId: user.profile.oid, sessionToken: token, locale: user.profile.locale, timeZone: new Date().getTimezoneOffset(), timeZoneId: new Intl.DateTimeFormat().resolvedOptions().timeZone } });
                    Utils.lsSet("access_token", token);

                }
            } else {
                // No token, or token is expired
                console.log("Renew 2 Token");
                prepareSilentTokenRequest();
                authContext._renewIdToken(function (err, idToken) {
                    if (err) {
                        console.log("Renewal 2 failed: " + err);
                        // Silent login failed (AADSTS16000 / AADSTS160021): let the user pick an
                        // account instead of staying on the spinner. window.self === window.top
                        // keeps this out of Teams and out of ADAL's renewal iframe.
                        if (!window.isTeamsGlobal && window.self === window.top) {
                            let lastRedirect = parseInt(window.sessionStorage.getItem("ri_login_redirect_at"), 10) || 0;
                            if (Date.now() - lastRedirect > 60000) { // no redirect loop
                                window.sessionStorage.setItem("ri_login_redirect_at", String(Date.now()));
                                // this cache cannot produce a token, drop it or we come straight back
                                authContext.clearCache();
                                authContext._user = null;
                                Utils.lsRemove("access_token");
                                window.sessionStorage.setItem("ri_select_account", "1"); // show the account picker
                                login();
                            }
                        }
                    } else {
                        // ADAL has a cached user now and adds its own hint, drop ours
                        prepareSilentTokenRequest();
                        if (idToken) {
                            authContext.acquireToken(iniGraphMicrosoft, function (error, access_token) {
                                if (error || !access_token) {
                                    console.log('ADAL 2 error occurred: ' + error);
                                }
                                else {
                                    setGraphProviderSignedIn();
                                    this.setState({ auth: { tenantId: user.profile.tid, userId: user.profile.oid, sessionToken: token, locale: user.profile.locale, timeZone: new Date().getTimezoneOffset(), timeZoneId: new Intl.DateTimeFormat().resolvedOptions().timeZone } });
                                    Utils.lsSet("access_token", token);
                                }
                            }.bind(this)
                            );
                        }
                    }
                });
            }
        }
    };

    render() {

        // If login related things immediately return Object
        if (window.location.pathname == "/loginResult")
            return (<ThemeProvider theme={theme}>
                <LoginResult path={pp} authContext={authContext} />
            </ThemeProvider>);
        else if (window.location.pathname == "/login")
            return (<ThemeProvider theme={theme}>
                <Login path={pp} />
            </ThemeProvider>);

        else if (window.location.pathname == "/logout")
            return (<ThemeProvider theme={theme}>
                <Logout path={pp} />
            </ThemeProvider>);

        let auth = { userId: this.state.auth != null ? this.state.auth.userId : "", locale: navigator.language || navigator.userLanguage, timeZone: new Date().getTimezoneOffset(), timeZoneId: new Intl.DateTimeFormat().resolvedOptions().timeZone };
        let token = authContext.getCachedToken(iniApplicationId);
        let access_token = authContext.getCachedToken(iniGraphMicrosoft);
        let withAdalAuthentication = false;
        let color;
        switch (window.location.pathname) {
            case "/shop/":
            case "/contact/":
            case "/impressum/":
            case "/privacy/":
            case "/shop":
            case "/contact":
            case "/impressum":
            case "/privacy":
                //case "/pricing":

                color = "white";
                break;

            default:
                color = this.state.backgroundColor
                break;
        }
        if (token && access_token) {
            // Check old Adal authentication
            setGraphProviderSignedIn();
            console.log("Old Adal Authentication");
            Utils.lsSet("access_token", token);
            Utils.lsSet("adal_authentication", "1");
        }

        if (Utils.lsGet("access_token") == null && Utils.lsGet("adal_authentication") == "0" && !window.location.pathname.includes("shop") && !window.location.pathname.includes("callDetail")) {
            // Check teams authentication
            if (this.timerID == null) {
                this.timerID = setInterval(() => this.checkTeamsAuthentication(), 2000);
                Utils.lsSet("adal_authentication", "1");
            }
            console.log("Authenticate...", this.timerID);
            return (
                <ThemeProvider theme={theme}>
                    <Spinner label="Authenticate..." ariaLive="assertive" labelPosition="top" />
                </ThemeProvider>);

        }
        else {
            return (
                <ThemeProvider theme={theme}>

                    <div className="App" style={{ color: theme.palette.neutralDark }}>

                        <ApolloProvider client={client}>
                            {/* Main Routing */}
                            <Route path="/" exact render={() => { return <div>{this.updateState(false, "/", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />

                            {/* Other Routing */}
                            <Route path="/rules/" exact render={() => { return <div>{this.updateState(false, "/rules", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/tenant/" exact render={() => { return <div>{this.updateState(false, "/tenant", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/ticket/" exact render={() => { return <div>{this.updateState(false, "/ticket", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/day/" render={() => { return <div>{this.updateState(false, "/day", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/upload/" exact render={() => { return <div>{this.updateState(false, "/upload", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/compliance/" render={() => { return <div>{this.updateState(false, "/compliance", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/dashboard/" render={() => { return <div>{this.updateState(false, "/dashboard", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/report/" render={() => {
                                return <ReportView path={pp} theme={this.props.theme} />
                            }} />
                            <Route path="/liveView/" render={() => { return <div>{this.updateState(false, "/liveView", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />

                            <Route path="/config/" render={() => { return <Config path={pp} /> }} />
                            {/* <Route path="/shop/" render={() => { return <div><ShopControler authorization={this.state.auth} apol={client} page={0} /></div> }} /> */}
                            <Route path="/configure/" render={() => { return <div><span style={{ padding: "10px", cursor: "pointer" }}><Icon onClick={this.switchView} iconName={"Home"} /></span><Setter authorization={this.state.auth} apol={client} /></div> }} />
                            {/* <Route path="/return/" render={() => { return <div><ShopControler authorization={this.state.auth} apol={client} page={2} /></div> }} /> */}
                            <Route path="/settings/" render={() => { return <div>{this.updateState(false, "/settings", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            {/* <Route path="/pricing/" render={() => { return <Pricing authorization={this.state.auth} path={pp} /> }} /> */}
                            <Route path="/conversations/" render={() => { return <div>{this.updateState(true, "/", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/users/" render={() => { return <div>{this.updateState(true, "/", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/tags/" render={() => { return <div>{this.updateState(true, "/", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route exact path="/main/" render={() => { return <div>{this.updateState(true, "/", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/zoom/" render={() => { return <div>{this.updateState(true, "/zoom", this.state, this.handler, this.switchView, this.ruleView, this.shopView, client)} </div> }} />
                            <Route path="/webex/" render={() => {
                                // OAuth callback handler - extract code from URL and send to parent tab
                                const params = new URLSearchParams(window.location.search);
                                const code = params.get('code');
                                const state = params.get('state');

                                if (code && state && window.opener) {
                                    // Send OAuth data to parent tab
                                    window.opener.postMessage({
                                        type: 'WEBEX_OAUTH_COMPLETE',
                                        code: code,
                                        state: state
                                    }, window.location.origin);

                                    console.log("✅ OAuth callback received, data sent to parent tab");
                                    window.close();
                                }

                                return <div style={{ padding: '20px', textAlign: 'center' }}>Completing authentication... You can close this tab.</div>;
                            }} />


                            {/* Legal Routing */}
                            <Route path="/privacy/" render={() => { return <Privacy path={pp} /> }} />
                            <Route path="/contact/" render={() => { return <Contact path={pp} /> }} />
                            <Route path="/product/" render={() => { return <Product path={pp} authorization={this.state.auth} apol={client} /> }} />
                            <Route path="/termsofuse/" render={() => { return <Termsofuse path={pp} /> }} />
                            <Route path="/impressum/" render={() => { return <Impressum path={pp} /> }} />
                            <Route path="/botRegistration/" render={() => { return <BotRegistration path={pp} /> }} />
                            <Route path="/shop/" render={() => { return <TransactableView path={pp} apol={client} /> }} />

                            {/*Sharing conversation using jwt tokn instead of authentication*/}
                            <Route path="/callDetail/" render={() => { return <DetailContainerStandalone path={pp} theme={theme} apol={client} /> }} />


                        </ApolloProvider>
                    </div>
                </ThemeProvider>
            );
        }
    }

    updateState(withMainMenu, type, st, handler, onCkHome, onCkRule, onShop, cc) {
        {

            let auth = { locale: navigator.language || navigator.userLanguage, timeZone: new Date().getTimezoneOffset(), timeZoneId: new Intl.DateTimeFormat().resolvedOptions().timeZone };

            let val = st.val;
            let filter = st.filter;
            let withSave = st.withSave;
            let searchIn = st.searchIn;
            console.log("auth: " + auth.locale + " " + auth.timeZone);
            let token = authContext.getCachedToken(iniApplicationId);
            let access_token = authContext.getCachedToken(iniGraphMicrosoft);
            let day = "";
            if (type === "/day") {
                let xx = window.location.href;
                let yy = xx.lastIndexOf('day');
                day = xx.substring(yy + 4, xx.length);
            }
            if (withMainMenu) {
                console.log("SelectedPivot: " + this.state.selectedPivot);
                Utils.lsRemove("selectedPivot");
            }
            if ((!token || !access_token) && !this.state.access_token) {

                // Dann SignIn
                return <MyContext.Consumer>
                    {(context) => (
                        <div>
                            <header className="app-header ms-Grid-row" style={{ backgroundColor: theme.palette.neutralLighterAlt, boxShadow: Depths.depth8 }} >
                                <Stack horizontal>
                                    <TooltipHost content={"Sign in Teams User"} hidden={Utils.lsGet("helpMode") === "false"} calloutProps={{ gapSpace: 0 }} delay={TooltipDelay.long} >
                                        <mgt-login class={theme.palette.black < "#100000" ? "mgt-light" : "mgt-dark"} person-card="hover"></mgt-login>
                                    </TooltipHost>
                                    <Stack.Item grow={2} ><div /></Stack.Item>

                                    <Stack.Item align="stretch">
                                        {type === "/rules" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("configuration", "configurationTitle")}</Text>}
                                        {type === "/zoom" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("configuration", "zoomAuthentication")}</Text>}
                                        {type === "/tenant" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("tenants", "tenantsTitle")}</Text>}
                                        {type === "/ticket" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("settings", "ticket")}</Text>}
                                        {type === "/settings" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("settings", "settingsTitle")}</Text>}
                                        {type === "/upload" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("upload", "uploadTitle")}</Text>}
                                        {type === "/dashboard" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("dashboard", "dashboardTitle")}</Text>}
                                        {type === "/liveView" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("dashboard", "liveView")}</Text>}
                                        {type === "/main" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>ASC Recording Insights </Text>}
                                        {type === "/compliance" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("compliance", "complianceTitle")}</Text>}
                                        {type === "/day" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>DayView {day}</Text>}
                                        {type === "/" && st.id === "2" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("conversationSafe", "conversationSafeTitle")}</Text>}
                                        {type === "/" && st.id === "3" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("detailContainer", "myQueue")}</Text>}

                                    </Stack.Item>
                                    <Stack.Item align="end">
                                        <div style={{ padding: "8px", fontSize: FontSizes.icon, textAlign: "right" }} >
                                            <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }} onClick={
                                                () => {
                                                    if (type === "/") {
                                                        if (!this.state.iconView) {
                                                            Utils.lsSet("refreshView", "list")
                                                        } else {
                                                            Utils.lsSet("refreshView", "icon")
                                                        }
                                                    }
                                                    window.location.reload(false);
                                                }
                                            } iconName={"Sync"}
                                                title={context.getTranslation("common", "refresh")}
                                            />
                                        </div>
                                    </Stack.Item>
                                </Stack>

                            </header>
                        </div>)}
                </MyContext.Consumer>
            }

            return (<MyContext.Consumer>
                {(context) => (
                    <div>
                        <Query
                            query={queryGetAuth}
                            variables={{ auth, val }}  >
                            {({ loading, error, data }) => {
                                if (loading) return <div><Spinner label={context.getTranslation("configuration", "checkAccessRules")} ariaLive="assertive" labelPosition="top" /></div>;
                                if (error) return <div></div>;
                                let loginValid = (data.getAuth == null || !data.getAuth.valid) ? false : true;

                                let viewSetting = false;  //default list

                                //is data exists and si != list set to  grid
                                if (data !== null && data.getAuth !== null) {
                                    if (data.getAuth.viewType !== "list") {
                                        viewSetting = true;
                                    }
                                }

                                if ((this.state.iconView != viewSetting) && this.state.isRefresh === true) {
                                    this.switchView();
                                }
                                if ((this.state.iconView != viewSetting) && this.state.isConversationSafeNew === true && this.state.id == "2") {
                                    this.switchView();
                                }
                                const styleConversationSafeContainer = { marginLeft: "10px", marginRight: "10px", marginTop: "-5px" }

                                return (
                                    <div>
                                        {type !== "/liveView" && <header className={withMainMenu ? "app-header-main" : "app-header"} style={{ background: theme.palette.white, boxShadow: Depths.depth8 }} >
                                            {withMainMenu && type !== "/zoom" && <Stack horizontal>
                                                <a href="https://www.asctechnologies.com"><img src={solutenLogo} height="32px" className="headerLogo" /></a>
                                                {this.getTitle()}
                                                <Pivot aria-label="ASC Recording Insights" onLinkClick={this.showPivotItem} selectedKey={this.state.selectedPivot}>
                                                    <PivotItem headerText={context.getTranslation("configuration", "recording")} itemKey=".0">
                                                    </PivotItem>
                                                    <PivotItem headerText={context.getTranslation("dashboard", "dashboardTitle")} itemKey=".1">
                                                    </PivotItem>
                                                    <PivotItem headerText={context.getTranslation("compliance", "complianceTitle")} itemKey=".2">
                                                    </PivotItem>
                                                    <PivotItem headerText={context.getTranslation("settings", "settingsTitle")} itemKey=".3">
                                                    </PivotItem>
                                                    {(data.getAuth != null && data.getAuth.ruleAccess != null && (data.getAuth.ruleAccess.confUserConfig || (data.getAuth.ruleAccess.confAddUser || data.getAuth.ruleAccess.confListUser))) &&
                                                        <PivotItem headerText={context.getTranslation("configuration", "configurationTitle")} itemKey=".4">
                                                        </PivotItem>
                                                    }
                                                    {(data.getAuth != null && data.getAuth.ruleAccess != null && ((data.getAuth.ruleAccess.confTenants) || (data.getAuth.ruleAccess.confTenants == null && (data.getAuth.ruleAccess.tenantCreate || data.getAuth.ruleAccess.tenantChange)))) &&

                                                        <PivotItem headerText={context.getTranslation("tenants", "tenantsTitle")} itemKey=".5">
                                                        </PivotItem>
                                                    }
                                                    {(data.getAuth != null && data.getAuth.ruleAccess != null && (data.getAuth.ruleAccess.confTicket) && data.getAuth.showTicketPage) &&
                                                        <PivotItem headerText={context.getTranslation("settings", "ticket")} itemKey=".6">
                                                        </PivotItem>
                                                    }
                                                </Pivot>
                                            </Stack>}
                                            <Stack horizontal >
                                                {(type === "/" && ((this.state.selectedPivot === ".0" && st.id !== "2" && st.id !== "3") || this.state.selectedPivot === ".2")) && <Icon onClick={onCkHome} iconName={this.state.iconView === true ? "List" : "ContactCard"} style={{ padding: "10px", cursor: "pointer", fontSize: FontSizes.icon }} />}
                                                {Utils.lsGet("adal_authentication") == "1" && (window.innerWidth < 600) && <mgt-login class={theme.palette.black < "#100000" ? "mgt-light app-login-small" : "mgt-dark app-login-small"} person-card="hover"></mgt-login>}
                                                {Utils.lsGet("adal_authentication") == "1" && (window.innerWidth >= 600) && <mgt-login class={theme.palette.black < "#100000" ? "mgt-light" : "mgt-dark"} person-card="hover"></mgt-login>}

                                                {loginValid && (type === "/" && (st.id !== "2" && st.id !== "3") && this.state.selectedPivot === ".0") &&
                                                    <div style={{ padding: "8px", fontSize: FontSizes.icon }}>
                                                        {(window.innerWidth < 600) && <FilterBox theme={theme} userRules={data.getAuth} sizeSmall="true" style={{ padding: "0px", fontSize: FontSizes.icon }} handler={handler} tooltip="Search conversations that contain the typed text in title, transcript or notes" authorization={auth} />}
                                                        {(window.innerWidth >= 600) && <FilterBox theme={theme} userRules={data.getAuth} style={{ padding: "0px", fontSize: FontSizes.icon }} handler={handler} tooltip="Search conversations that contain the typed text in title, transcript or notes" authorization={auth} />}

                                                    </div>
                                                }

                                                <Stack.Item grow={2}>
                                                    {(type !== "/" || st.id === "2" || st.id === "3" || this.state.selectedPivot != ".0") && <div style={{ padding: "14px", fontSize: FontSizes.icon }}>
                                                        {!loginValid && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>ASC Recording Insights</Text>}
                                                        {loginValid && type === "/rules" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("configuration", "configurationTitle")}</Text>}
                                                        {loginValid && type === "/zoom" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("configuration", "zoomAuthentication")}</Text>}
                                                        {loginValid && type === "/tenant" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("tenants", "tenantsTitle")}</Text>}
                                                        {loginValid && type === "/ticket" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("settings", "ticket")}</Text>}
                                                        {loginValid && type === "/settings" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("settings", "settingsTitle")}</Text>}
                                                        {loginValid && type === "/upload" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("upload", "uploadTitle")}</Text>}
                                                        {loginValid && type === "/dashboard" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("dashboard", "dashboardTitle")}</Text>}
                                                        {loginValid && type === "/liveView" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("dashboard", "liveView")}</Text>}
                                                        {loginValid && type === "/compliance" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("compliance", "complianceTitle")}</Text>}
                                                        {loginValid && type === "/day" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>DayView {day}</Text>}
                                                        {loginValid && type === "/" && this.state.selectedPivot == ".0" && st.id === "2" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("conversationSafe", "conversationSafeTitle")}</Text>}
                                                        {loginValid && type === "/" && this.state.selectedPivot == ".0" && st.id === "3" && <Text style={{ padding: "14px", fontSize: FontSizes.icon }}>{context.getTranslation("detailContainer", "myQueue")}</Text>}

                                                    </div>}
                                                </Stack.Item>
                                                <Stack.Item align="end">
                                                    <div style={{ padding: "8px", fontSize: FontSizes.icon, textAlign: "right", display: "flex" }} >
                                                        {(type === "/" && this.state.selectedPivot == ".0") && data.getAuth != null && data.getAuth.ruleAccess != null &&
                                                            <div style={{ marginTop: "7px", height: "32px" }}>
                                                                <Toggle
                                                                    onText={context.getTranslation("common", "newui")}
                                                                    offText={context.getTranslation("common", "newui")}
                                                                    onChange={(ev, checked) => {
                                                                        window.sessionStorage.setItem("enabledNewUI", "YES")
                                                                        window.location.href = window.location.origin + "/ui/main?enabledNewUI=YES"
                                                                    }}
                                                                />
                                                            </div>
                                                        }

                                                        {(type === "/" && this.state.selectedPivot == ".0") && data.getAuth != null && data.getAuth.ruleAccess != null && data.getAuth.ruleAccess.userLiveView && <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }} onClick=
                                                            {
                                                                () => {
                                                                    this.showLiveView();
                                                                }
                                                            }
                                                            iconName={"InternetSharing"}
                                                            title={context.getTranslation("common", "liveView")}
                                                        />}
                                                        {(type === "/" && this.state.selectedPivot == ".0") && data.getAuth != null && data.getAuth.ruleAccess != null
                                                            && data.getAuth.ruleAccess.userSafe !== "No" && st.id !== "2" &&
                                                            <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }}
                                                                onClick={() => {
                                                                    this.setState({ id: "2", backgroundColor: '#F7F7F7', iconView: viewSetting });
                                                                }}
                                                                iconName={"LockSolid"}
                                                                title={context.getTranslation("detailContainer", "conversationSafe")}
                                                            />}
                                                        {(type === "/" && this.state.selectedPivot == ".0") && st.id !== "3" && data.getAuth.addOnCaseManagement && data.getAuth.ruleAccess.userSafe !== "No" &&
                                                            <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }}
                                                                onClick={() => {
                                                                    this.setState({ id: "3", backgroundColor: '#F7F7F7', iconView: viewSetting });
                                                                }}
                                                                iconName={"ReportWarning"}
                                                                title={context.getTranslation("detailContainer", "myQueue")}
                                                            />}
                                                        {type === "/day" && <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }} onClick=
                                                            {
                                                                () => {
                                                                    this.onCkHome();
                                                                }
                                                            }
                                                            iconName={"Home"} />}

                                                        {loginValid && <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }} onClick=
                                                            {
                                                                () => {
                                                                    this.setState({ helpPanel: true });
                                                                }
                                                            } iconName={"Help"}
                                                            title={context.getTranslation("common", "help")}
                                                        />}
                                                        <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }} onClick={
                                                            () => {
                                                                if (st.id === "2") {
                                                                    if (!this.state.iconView) {
                                                                        Utils.lsSet("refreshView", "list");
                                                                    } else {
                                                                        Utils.lsSet("refreshView", "icon");
                                                                    }
                                                                    window.localStorage.setItem("saved_state", "2");
                                                                    window.location.reload(false);
                                                                } else if (st.id === "3") {
                                                                    if (!this.state.iconView) {
                                                                        Utils.lsSet("refreshView", "list");
                                                                    } else {
                                                                        Utils.lsSet("refreshView", "icon");
                                                                    }
                                                                    window.localStorage.setItem("saved_state", "3");
                                                                    window.location.reload(false);
                                                                } else {
                                                                    if (!this.state.iconView) {
                                                                        Utils.lsSet("refreshView", "list")
                                                                    } else {
                                                                        Utils.lsSet("refreshView", "icon")
                                                                    }
                                                                    Utils.lsSet("selectedPivot", this.state.selectedPivot);
                                                                    window.location.reload(false);
                                                                }
                                                            }
                                                        } iconName={"Sync"}
                                                            title={context.getTranslation("common", "refresh")}
                                                        />
                                                        {(type === "/" && this.state.selectedPivot == ".0" && (st.id === "2" || st.id === "3")) && <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }} onClick={
                                                            () => {
                                                                if (!this.state.iconView) {
                                                                    Utils.lsSet("refreshView", "list")
                                                                } else {
                                                                    Utils.lsSet("refreshView", "icon")
                                                                }
                                                                window.localStorage.setItem("saved_state", "0");
                                                                window.location.reload(false);
                                                            }
                                                        }
                                                            iconName={"Cancel"} />
                                                        }
                                                        {(type == "/rules" || type == "/tenant" || type == "/ticket") &&
                                                            <Icon style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.icon }} onClick={
                                                                () => {
                                                                    if (type === "/rules") {
                                                                        window.location.href = window.location.origin + "/settings";

                                                                    }
                                                                    if (type === "/tenant") {
                                                                        window.location.href = window.location.origin + "/settings";

                                                                    }
                                                                    if (type === "/ticket") {
                                                                        window.location.href = window.location.origin + "/settings";

                                                                    }

                                                                }
                                                            } iconName={"Cancel"} />}

                                                        {!loginValid && renderPanelRecording(this, theme.palette.neutralPrimary)}
                                                        {loginValid && (type === "/" && this.state.selectedPivot == ".0") && renderPanelRecording(this, auth, client, data.getAuth, theme.palette.neutralPrimary)}
                                                        {loginValid && (type === "/rules" || this.state.selectedPivot === ".4") && renderPanelRules(this, auth, client, data.getAuth, theme)}
                                                        {loginValid && (type === "/tenant" || this.state.selectedPivot === ".5") && renderPanelTenant(this, auth, client, data.getAuth, theme)}
                                                        {loginValid && (type === "/settings" || this.state.selectedPivot === ".3") && renderPanelSettings(this, auth, client, data.getAuth, theme)}
                                                        {loginValid && (type === "/dashboard" || this.state.selectedPivot === ".1") && renderPanelDashboard(this, auth, client, data.getAuth, theme)}
                                                        {loginValid && (type === "/compliance" || this.state.selectedPivot === ".2") && renderPanelCompliance(this, auth, client, data.getAuth, theme)}
                                                        {loginValid && type === "/upload" && renderPanelUpload(this, auth, client, data.getAuth, theme)}
                                                        {loginValid && type === "/day" && renderPanelRecording(this, auth, client, data.getAuth, theme.palette.neutralPrimary)}
                                                        {loginValid && type === "/ticket" && renderPanelTicket(this, auth, client, data.getAuth, theme)}

                                                        <LiveView ref={this.LiveViewRef} client={cc} authorization={auth} userRules={data.getAuth} />
                                                    </div>
                                                </Stack.Item>
                                            </Stack>
                                        </header>}
                                        <div className={(type === "/liveView") ? "" : (withMainMenu ? "app-body-main" : "app-body")} style={{ backgroundColor: theme.palette.neutralLighterAlt }}>
                                            <div>
                                                {!loginValid && <ProductLicense authorization={st.auth} apol={cc} />}
                                                {loginValid && type === "/" && this.state.selectedPivot == ".0" && st.id === "0" && renderSearchTeams(this.state.iconView, "", null, false, auth, cc, data.getAuth, window.location.href, theme, searchIn)}
                                                {loginValid && type === "/" && this.state.selectedPivot == ".0" && st.id === "1" && renderSearchTeams(this.state.iconView, val, filter, withSave, auth, cc, data.getAuth, window.location.href, theme, searchIn)}
                                                {loginValid && type === "/" && this.state.selectedPivot == ".0" && st.id === "2" && <div style={styleConversationSafeContainer}><ConversationSafe apol={client} auth={auth} userRules={data.getAuth} theme={theme} /></div>}
                                                {loginValid && type === "/" && this.state.selectedPivot == ".0" && st.id === "3" && <div style={styleConversationSafeContainer}><MyQueue apol={client} auth={auth} userRules={data.getAuth} theme={theme} /></div>}
                                                {loginValid && (type === "/rules" || this.state.selectedPivot === ".4") && (data.getAuth.ruleAccess.confUserConfig || (data.getAuth.ruleAccess.confAddUser || data.getAuth.ruleAccess.confListUser)) && <Setter authorization={auth} apol={client} userRules={data.getAuth} theme={theme} />}
                                                {loginValid && (type === "/zoom") && renderZoomAuthorize(this.state.iconView, "", null, false, auth, cc, data.getAuth, window.location.href, theme)}
                                                {loginValid && (type === "/webex") && renderWebexAuthorize(this.state.iconView, "", null, false, auth, cc, data.getAuth, window.location.href, theme)}
                                                {loginValid && (type === "/tenant" || this.state.selectedPivot === ".5") && data.getAuth != null && data.getAuth.ruleAccess != null && ((data.getAuth.ruleAccess.confTenants) || (data.getAuth.ruleAccess.confTenants == null && (data.getAuth.ruleAccess.tenantCreate || data.getAuth.ruleAccess.tenantChange))) && <SetterTenant authorization={auth} apol={client} userRules={data.getAuth} theme={theme} />}
                                                {loginValid && (type === "/ticket" || this.state.selectedPivot === ".6") && data.getAuth != null && data.getAuth.ruleAccess != null && (data.getAuth.ruleAccess.confTicket) && data.getAuth.showTicketPage && <SetterTicket authorization={auth} apol={client} userRules={data.getAuth} />}
                                                {loginValid && type === "/upload" && <Upload authorization={auth} apol={client} userRules={data.getAuth} />}
                                                {loginValid && (type === "/settings" || this.state.selectedPivot === ".3") && <SettingsView authorization={auth} apol={client} path={pp} userRules={data.getAuth} />}
                                                {loginValid && (type === "/dashboard" || this.state.selectedPivot === ".1") && <DashboardView authorization={auth} apol={client} path={pp} userRules={data.getAuth} theme={theme} />}
                                                {loginValid && type === "/liveView" && <LiveViewOnly authorization={auth} apol={client} path={pp} userRules={data.getAuth} theme={theme} />}
                                                {loginValid && (type === "/compliance" || this.state.selectedPivot === ".2") && (data.getAuth.addOnCompliance || data.getAuth.license === "10" || (data.getAuth.addOnAIEntry && data.getAuth.ruleAccess.allowAiQuestionsWithoutCompliance)) && data.getAuth.ruleAccess.userCompliancePolicy && <ComplianceView authorization={auth} apol={client} path={pp} userRules={data.getAuth} theme={theme} iconView={this.state.iconView} />}
                                                {loginValid && (type === "/compliance" || this.state.selectedPivot === ".2") && (!data.getAuth.ruleAccess.userCompliancePolicy || !(data.getAuth.addOnCompliance || data.getAuth.license === "10" || (data.getAuth.addOnAIEntry && data.getAuth.ruleAccess.allowAiQuestionsWithoutCompliance))) && <ComplianceLicense authorization={auth} apol={client} path={pp} userRules={data.getAuth} theme={theme} iconView={this.state.iconView} />}
                                                {loginValid && type === "/day" && <DayView authorization={auth} apol={client} path={pp} userRules={data.getAuth} />}

                                            </div>
                                        </div>
                                    </div>);
                            }
                            }
                        </Query></div>)}
            </MyContext.Consumer>);
        }
    }

    onCkHome = () => {
        window.location.href = "/";
    }

    showLiveView = () => {
        this.LiveViewRef.current.showPanel(Utils.guidGenerator())
    };

    showPivotItem = (item, ev) => {
        const enabledNewUI = window.sessionStorage.getItem("enabledNewUI");
        if (enabledNewUI === "YES") {
            if (item.key === ".0") {
                window.location.href = window.location.origin + "/ui/main";
            } /*else if (item.key === ".2") {
            window.location.href = window.location.origin + "/ui/main/compliance";
            ecc
        }*/
        }

        //and all other tabs
        this.setState({ selectedPivot: item.key })
    }

    getTitle = () => {
        const width = this.state.clientWidth
        const style = { fontWeight: "600" }
        if (width > 900) {
            return <span style={{ ...style, marginTop: "12px", marginRight: "20px", fontSize: "16px" }} > ASC Recording Insights</ span>
        } else if (width <= 900 && width > 843) {
            return <span style={{ ...style, marginTop: "14px", marginRight: "5px", fontSize: "14px" }} > ASC Recording Insights</ span>
        } else if (width <= 843 && width > 750) {
            return <span style={{ ...style, marginTop: "15px", marginRight: "5px", fontSize: "14px" }} > ASC RI</ span>
        }
        return ""
    }
}